export const formatTimeAgo = (timestamp: string | number): string => {
  let dateTime: Date;

  // Handle string or number input
  if (typeof timestamp === 'string') {
    // Append 'Z' if not present to ensure UTC
    const isUTC = timestamp.endsWith('Z');
    const normalizedTimestamp = isUTC ? timestamp : `${timestamp}Z`;
    dateTime = new Date(normalizedTimestamp);
  } else {
    dateTime = new Date(timestamp);
  }

  if (isNaN(dateTime.getTime())) return 'Invalid date';

  const now = new Date();
  const utcNow = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds()
    )
  );

  const diffMs = utcNow.getTime() - dateTime.getTime();
  const diffMins = Math.round(diffMs / (1000 * 60));

  if (diffMins < 1) {
    return 'just now';
  } else if (diffMins === 1) {
    return '1 min ago';
  } else if (diffMins < 60) {
    return `${diffMins} mins ago`;
  }

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) {
    return `${diffHours} hrs ago`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) {
    return `${diffDays} days ago`;
  }

  const diffWeeks = Math.floor(diffDays / 7);
  if (diffWeeks < 4) {
    return `${diffWeeks} weeks ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return diffMonths <= 1 ? `A month ago` : `${diffMonths} months ago`;
  }

  const diffYears = Math.floor(diffDays / 365);
  return diffYears <= 1 ? `A year ago` : `${diffYears} years ago`;
};



export const formatDate = (dateString: string) => {
  if (!dateString) return "-";

  let normalized = dateString.trim();

  // ✅ Handle cases like "2025-09-12T02:15:23.806+00:00"
  // Replace "+00:00" or "+05:30" etc. with "Z" or normalized UTC offset
  if (/^\d{4}-\d{2}-\d{2}T/.test(normalized)) {
    // If it ends with timezone offset like +00:00 or -05:30, convert it properly
    if (/\+\d{2}:\d{2}$/.test(normalized) || /-\d{2}:\d{2}$/.test(normalized)) {
      normalized = normalized.replace(/(\+|-)(\d{2}):(\d{2})$/, "$1$2$3"); // make it +0000 style (valid ISO)
    } else if (!normalized.endsWith("Z")) {
      normalized += "Z"; // fallback to UTC
    }
  }

  const date = new Date(normalized);

  // ✅ Validate the date
  if (isNaN(date.getTime())) {
    console.warn("Invalid date passed to formatDate:", dateString);
    return "-";
  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const formatted = date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone,
  });

  return `${formatted.replace(",", "")} `;
};


